// Buyer file requests: Physical File or Google Drive Only (Henry, 09/25/2026).
// Physical File: the team is told (bell, push, email) and it waits in the File Requests queue.
// Google Drive Only: the Drive folder is made for the agent and nobody else is told.
// Import-free on purpose: the File Requests queue filter uses this and must stay pure.

export const PHYSICAL_FILE = "Physical File";
export const DRIVE_ONLY = "Google Drive Only";
export const BUYER_FILE_FORMATS = [PHYSICAL_FILE, DRIVE_ONLY];

// Older buyer requests used three answers. "Full Digital" meant no paper, so it reads as Drive only;
// "Full Physical", "Part Physical & Digital" and a blank read as physical, so nothing already waiting
// drops out of the queue.
export function isDriveOnlyFormat(fileFormat) {
  return fileFormat === DRIVE_ONLY || fileFormat === "Full Digital";
}

// Only a buyer request can be Drive only; listing (seller) requests are unchanged.
export function isDriveOnlyRequest(deal) {
  return !!deal && deal.dealtype === "Buyer" && isDriveOnlyFormat(deal.fileFormat);
}
